import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import _ from 'lodash'

class StatisticsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.employee) > 0) {
      return <div><Table employee={this.props.employee}></Table></div>
    }
    return <div style={{marginLeft: '150px'}}>Loading</div>
  }
}

StatisticsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default StatisticsComponent
